import isEqual from "lodash/isEqual";
import { createRecord } from "Utils";
const createHiddenGroupData = ({ Id, Name }) => ({
    Id,
    Name,
    Icon: null,
    X: null,
    Y: null,
    Width: null,
    Height: null,
    GraphPorts: []
});
export const prepareGroups = ({ documentGraphData, prevData, deletedGroupsIds }) => {
    var _a;
    const groupsSourceForServer = new Map();
    const prevDataGroups = createRecord(prevData.DataGroups, "Id");
    const groupsOnGraph = new Map(documentGraphData.DataGroups.map(item => [item.Id, item]));
    const groupsForServer = new Map();
    const addGroupForServer = (item) => {
        var _a;
        if (item) {
            groupsSourceForServer.set(item.Id, item);
            groupsForServer.set(item.Id, (_a = groupsOnGraph.get(item.Id)) !== null && _a !== void 0 ? _a : createHiddenGroupData(item));
        }
    };
    (_a = documentGraphData.Groups) === null || _a === void 0 ? void 0 : _a.forEach(item => {
        const prev = prevData.Groups[item.Id];
        if (!prev) {
            addGroupForServer(item);
        }
        if (isEqual(prev, item)) {
            return;
        }
        addGroupForServer(item);
    });
    documentGraphData.DataGroups.forEach(item => {
        if (groupsForServer.has(item.Id)) {
            return;
        }
        const prev = prevDataGroups[item.Id];
        if (isEqual(prev, item)) {
            return;
        }
        const prevGroupSource = prevData.Groups[item.Id];
        addGroupForServer(prevGroupSource);
    });
    const currentGroups = [...documentGraphData.DataGroups];
    prevData.DataGroups.forEach(group => {
        if (!deletedGroupsIds.includes(group.Id) && !groupsOnGraph.has(group.Id)) {
            currentGroups.push(group);
        }
    });
    return {
        groupsSourceForServer,
        groupsForServer,
        currentGroups
    };
};
